import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import Home from '@/views/Home.vue';

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push as any;
VueRouter.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((error: Error) => {
    console.log(error);
  });
};
const isAuth = () => store.state.auth.isAuth;
const lastGroupId = () => store.state.auth.lastGroupId;
const isIE = () => /MSIE |Trident\//.test(window.navigator.userAgent);

const requireAuth = async (to: any, from: any, next: any) => {
  // 프로필, 랩관리에서 사용 인증 안되면 홈으로 이동
  if (isAuth()) return next();
  next('/');
};

const requireHome = (to: any, from: any, next: any) => {
  // 홈에서 사용자 인증 했을때
  if (isAuth()) {
    let groupId: string = lastGroupId() || 'welcome';
    if (to.path === '/') {
      next({
        path: `/groups/${groupId}/inventory`,
      });
    } else next();
  } else {
    next();
  }
};

const routes = [
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "AuthEmail" */ '../views/NotFound.vue'),
  },
  {
    path: '/ie',
    name: 'IE',
    component: () => import(/* webpackChunkName: "AuthEmail" */ '../views/IE.vue'),
  },
  {
    path: '/',
    name: 'Home',
    props: true,
    meta: {
      isModalLogin: false,
      isModalFindPassword: false,
      isModalRegister: false,
    },
    component: Home,
    beforeEnter: requireHome,
    children: [
      {
        path: '/login',
        name: 'Login',
        props: true,
        meta: {
          isModalLogin: true,
          isModalFindPassword: false,
          isModalRegister: false,
        },
        component: () =>
          import(/* webpackChunkName: "AuthEmail" */ '../components/auth/ModalLogin.vue'),
      },
      {
        path: '/register',
        name: 'Register',
        meta: {
          isModalLogin: false,
          isModalFindPassword: false,
          isModalRegister: true,
        },
        component: () =>
          import(/* webpackChunkName: "AuthEmail" */ '../components/auth/ModalRegister.vue'),
      },
      {
        path: '/forgot',
        name: 'Forgot',
        meta: {
          isModalLogin: false,
          isModalFindPassword: true,
          isModalRegister: false,
        },
        component: () =>
          import(/* webpackChunkName: "AuthEmail" */ '../components/auth/ModalFindPassword.vue'),
      },
    ],
  },
  {
    path: '/auth/register/:code',
    name: 'AuthEmail',
    component: () => import(/* webpackChunkName: "AuthEmail" */ '../views/redirect/AuthEmail.vue'),
  },
  {
    path: '/auth/forgot/:code',
    name: 'NewPassWordEmail',
    component: () =>
      import(/* webpackChunkName: "NewPassWordEmail" */ '../views/redirect/NewPassWordEmail.vue'),
  },
  {
    path: '/auth/invite/:code',
    name: 'MemberInvite',
    component: () =>
      import(/* webpackChunkName: "MemberInvite" */ '../views/redirect/MemberInvite.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/profile/index.vue'),
    beforeEnter: requireAuth,
    redirect: {
      name: 'ChangeProfile',
    },
    children: [
      {
        path: '',
        name: 'ChangeProfile',
        component: () =>
          import(
            /* webpackChunkName: "changeProfile" */ '../views/profile/changeProfile/index.vue'
          ),
      },
      {
        path: 'password',
        name: 'ChangePassword',
        component: () =>
          import(
            /* webpackChunkName: "changePassword" */ '../views/profile/changePassword/index.vue'
          ),
      },
      {
        path: 'email-settings',
        name: 'AlarmEmail',
        component: () =>
          import(/* webpackChunkName: "alarmEmail" */ '../views/profile/alarmEmail/index.vue'),
      },
      {
        path: 'credit-cards',
        name: 'ChangeCreditCards',
        component: () =>
          import(
            /* webpackChunkName: "changeCreditCards" */ '../views/profile/changeCreditCards/index.vue'
          ),
      },
    ],
  },
  {
    path: '/manage-groups',
    name: 'ManageGroup',
    component: () => import(/* webpackChunkName: "manageGroup" */ '../views/manageGroup/index.vue'),
    redirect: {
      name: 'Members',
    },
    beforeEnter: requireAuth,
    children: [
      {
        path: ':groupId',
        redirect: {
          name: 'Members',
        },
      },
      {
        path: ':groupId/members',
        name: 'Members',
        component: () =>
          import(/* webpackChunkName: "members" */ '../views/manageGroup/members/index.vue'),
      },
      {
        path: ':groupId/locations',
        name: 'Locations',
        component: () =>
          import(/* webpackChunkName: "locations" */ '../views/manageGroup/locations/index.vue'),
      },
      {
        path: ':groupId/types',
        name: 'Types',
        component: () =>
          import(/* webpackChunkName: "types" */ '../views/manageGroup/types/index.vue'),
      },
      {
        path: ':groupId/vendors',
        name: 'Vendors',
        component: () =>
          import(/* webpackChunkName: "vendors" */ '../views/manageGroup/vendors/index.vue'),
      },
      {
        path: ':groupId/manufacturers',
        name: 'Manufacturers',
        component: () =>
          import(
            /* webpackChunkName: "manufacturers" */ '../views/manageGroup/manufacturers/index.vue'
          ),
      },
      {
        path: ':groupId/addresses',
        name: 'Addresses',
        component: () =>
          import(/* webpackChunkName: "addresses" */ '../views/manageGroup/addresses/index.vue'),
      },
      {
        path: ':groupId/settings',
        name: 'Settings',
        component: () =>
          import(/* webpackChunkName: "settings" */ '../views/manageGroup/settings/index.vue'),
      },
    ],
  },
  {
    path: '/groups',
    name: 'Container',
    component: () => import(/* webpackChunkName: "Container" */ '../views/Container.vue'),
    redirect: {
      name: 'ContentView',
    },
    // beforeEnter: requireGroups,
    children: [
      {
        path: ':groupId',
        redirect: {
          name: 'ContentView',
        },
      },
      {
        path: ':groupId/inventory',
        name: 'Inventory',
        component: () => import(/* webpackChunkName: "inventory" */ '../views/inventory/index.vue'),
        redirect: {
          name: 'ContentView',
        },
        children: [
          {
            path: '',
            name: 'ContentView',
            component: () =>
              import(/* webpackChunkName: "contentView" */ '../views/inventory/ContentView.vue'),
            pathToRegexpOptions: {
              strict: true,
            },
            children: [
              {
                path: ':inventoryId',
                name: 'DrawerInventoryItem',
                props: true,
                meta: {
                  drawer: true,
                },
                component: () =>
                  import(
                    /* webpackChunkName: "drawerRequestItem" */ '../components/inventory/drawerItem/index.vue'
                  ),
              },
            ],
          },
        ],
      },
      {
        path: ':groupId/requests',
        name: 'Request',
        component: () => import(/* webpackChunkName: "request" */ '../views/request/index.vue'),
        redirect: {
          name: 'StatusView',
        },
        children: [
          {
            path: '',
            name: 'StatusView',
            component: () =>
              import(/* webpackChunkName: "statusView" */ '../views/request/StatusView.vue'),
            pathToRegexpOptions: {
              strict: true,
            },
            children: [
              {
                path: ':requestId',
                name: 'DrawerRequestItem',
                props: true,
                meta: {
                  drawer: true,
                },
                component: () =>
                  import(
                    /* webpackChunkName: "drawerRequestItem" */ '../components/request/drawerItem/index.vue'
                  ),
              },
            ],
          },
        ],
      },
      {
        path: ':groupId/purchase-order',
        name: 'PurchaseOrder',
        component: () =>
          import(/* webpackChunkName: "purchaseOrder" */ '../views/purchaseOrder/index.vue'),
        beforeEnter(to: any, from: any, next: any) {
          if (from.name === null) {
            return next({
              path: `/groups/${to.params.groupId}/requests`,
            });
          }
          next();
        },
        children: [
          {
            path: ':purchaseOrderId',
            name: 'PurchaseOrderDetails',
          },
        ],
      },
      {
        path: ':groupId/requisition',
        name: 'Requisition',
        component: () =>
          import(/* webpackChunkName: "requisition" */ '../views/requisition/index.vue'),
        beforeEnter(to: any, from: any, next: any) {
          if (from.name === null) {
            return next({
              path: `/groups/${to.params.groupId}/requests`,
            });
          }
          next();
        },
      },
      {
        path: ':groupId/order-draft',
        name: 'OrderDraft',
        component: () =>
          import(/* webpackChunkName: "orderDraft" */ '../views/orderDraft/index.vue'),
        beforeEnter(to: any, from: any, next: any) {
          if (from.name === null) {
            return next({
              path: `/groups/${to.params.groupId}/requests`,
            });
          }
          next();
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (isIE()) {
    if (to.name === 'IE') return next();
    else return next({ name: 'IE' });
  }
  next();
});

export default router;
